import { logger } from 'packages/logger';
import { nullifyUndefinedProperties } from 'tradera/utils/object';
import { mapConfig } from './configuration-mapper';
import { STATUS } from './types';
import { itemQueries } from './item-queries';
import type { StartPageInitData, StartPageInitialState } from './types';

export default (initData: StartPageInitData = {}) => {
    const {
        isLoggedIn,
        startPageResponse,
        lastChance = { items: [], status: STATUS.NOT_FETCHED },
        trendingBrands = { items: [], status: STATUS.NOT_FETCHED },
        wishList = { items: [], status: STATUS.NOT_FETCHED },
        favouriteSellers = {
            sellers: [],
            sellerSuggestions: [],
            items: [],
            totalItems: 0,
            status: STATUS.NOT_FETCHED
        }
    } = initData;

    let config;
    if (startPageResponse?.config) {
        try {
            config = JSON.parse(startPageResponse.config);
        } catch (error) {
            logger(error);
        }
    }

    return nullifyUndefinedProperties({
        status: config ? STATUS.HAS_DATA : STATUS.NOT_FETCHED,
        config: mapConfig(config, isLoggedIn),
        lastChance,
        trendingBrands,
        wishList,
        favouriteSellers,
        itemQueries
    }) as StartPageInitialState;
};
